export const DEFAULT_EXPIRE = 15 * 60 // seconds
export const K_LOGINED_USER = 'logined-user'

let MSG_LOGIN = 1000
let MSG_AD = 1100
let MSG_UI_BASE = 1
let MSG_SYS_BASE = 100
let MSG_BIZ_LOCK = 2000 // 默认MSG_ID TH
export const MSG_ID = {
  MSG_UI_TOAST_ERR: MSG_UI_BASE + 1,
  MSG_UI_TOAST_SUCC: MSG_UI_BASE + 2,
  MSG_UI_TOAST_INFO: MSG_UI_BASE + 3,
  MSG_UI_CONFIRM: MSG_UI_BASE + 4,
  MSG_UI_SHOW_MODAL: MSG_UI_BASE + 5,
  MSG_UI_HIDE_MODAL: MSG_UI_BASE + 6,
  MSG_UI_FIX_CONTENT_HEIGHT: MSG_UI_BASE + 7,
  MSG_UI_TIP_SUCC: MSG_UI_BASE + 8,
  MSG_UI_TIP_ERR: MSG_UI_BASE + 9,
  MSG_UI_TIP_INFO: MSG_UI_BASE + 10,
  MSG_UI_TIP_WARN: MSG_UI_BASE + 11,
  MSG_UI_TIP: MSG_UI_BASE + 12,
  MSG_UI_INFLATE_SELECT2: MSG_UI_BASE + 13,

  MSG_SYS_NAVIGATION_REPLACE: MSG_SYS_BASE + 1,
  MSG_SYS_NAVIGATION_PUSH: MSG_SYS_BASE + 2,
  MSG_SYS_NAVIGATION_GO: MSG_SYS_BASE + 3,
  MSG_SYS_LOCAL_SESSION_SET: MSG_SYS_BASE + 4,
  MSG_SYS_LOCAL_SESSION_RESULT: MSG_SYS_BASE + 5,
  MSG_SYS_EXIT: MSG_SYS_BASE + 6,
  MSG_SYS_REAUTH: MSG_SYS_BASE + 7,
  MSG_SYS_REAUTH_SUCCESS: MSG_SYS_BASE + 8,
  MSG_SYS_REAUTH_FAIL: MSG_SYS_BASE + 9,
  MSG_ROLE_SET_SUCCESS: MSG_SYS_BASE + 10,
  MSG_ACCOUNT_SET_SUCCESS: MSG_SYS_BASE + 11,
  MSG_PERMISSION_SET_SUCCESS: MSG_SYS_BASE + 12,
  MSG_APIACS_SET_SUCCESS: MSG_SYS_BASE + 13,
  MSG_SYS_HORIZONTALMENU_RESET: MSG_SYS_BASE + 14,
  MSG_SYS_HORIZONTALMENU_CLICK: MSG_SYS_BASE + 15,
  MSG_USERPROFILE_LOAD: MSG_SYS_BASE + 16,

  MSG_LOGIN_START: MSG_LOGIN + 1,
  MSG_LOGIN_SUCCESS: MSG_LOGIN + 2,
  MSG_LOGIN_FAIL: MSG_LOGIN + 3,

  MSG_AD_TO_EDIT_CAMPAIGN: MSG_AD + 1,
  MSG_AD_CAMPAIGN_REFRESH: MSG_AD + 2,
  MSG_AD_ADVERTISMENT_REFRESH: MSG_AD + 3,
  MSG_AD_ADVERTISER_REFRESH: MSG_AD + 4,
  MSG_AD_CAMPAIGN_GET_CLICK_VIEW: MSG_AD + 5,
  MSG_AD_CAMPAIGN_REFRESH_CHART: MSG_AD + 6,
  MSG_AD_CAMPAIGN_CHANGE_ID: MSG_AD + 7,
  MSG_AD_CAMPAIGN_GET_VIEW_DETAIL: MSG_AD + 8,
  MSG_AD_CAMPAIGN_EDIT_FETCH_SUCC: MSG_AD + 9,

  // lock msg id define 定义对应的消息ID tH
  MSG_LOCK_REFRESH: MSG_BIZ_LOCK + 1,
  MSG_LOCK_ERR: MSG_BIZ_LOCK + 2,
  MSG_LOCK_SUCC: MSG_BIZ_LOCK + 3,
  MSG_LOCK_INFO: MSG_BIZ_LOCK + 4,

  MSG_NOTHING: 0
}

export const SER_RESP_CODE = {
  3000001: '无权访问api',
  3000002: 'session校验失败',
  3000011: '签名错误',
  5000000: '服务端内部异常',
  5000001: '非法的请求协议头',
  5000002: '请求格式错误',
  5000003: '系统参数无效:参数缺失/参数值无效'
}

export const OP_TYPE = {
  C: 1,
  U: 2,
  R: 3,
  D: 4
}

export const USER_PROFILE_DIM = {
  HOBBY: {name: '兴趣爱好', tag: 100},
  SEX: {name: '性别', tag: 101},
  TELCOM_CARRIER: {name: '运营商', tag: 102},
  PHONE_BRAND: {name: '手机品牌', tag: 103},
  PLATFORM: {name: '软件平台', tag: 104},
  NETWORK: {name: '移动网络', tag: 105},
  COMMUNITY: {name: '社区', tag: 106}
}



// WEBPACK FOOTER //
// ./src/lib/constant.js